import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import UserLicences from "./components/UserLicences";
import SalesChart from "./components/SalesChart";
import TopSellingEA from "./components/TopSellingEA";
import PurchaseKey from "./components/PurchaseKey";
import WelcomeJourneyCard from "./components/WelcomeJourneyCard";
import { useParams } from "react-router-dom";
import { decodeId } from "../../../../../../utils/hash";



export default function Dashboard() {
    const { setPageTitle, setPageUserID } = useAppContext();


    const { owner: userID } = useParams();
    const userId = userID ? decodeId(userID) : null;

    const [licenseStats, setLicenseStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);


    useEffect(() => {
        setPageUserID(userId);
        setPageTitle("Dashboard");
    }, [setPageTitle, setPageUserID, userId]);

    return (
        <UserPageLayout>

            <div className="content-body">
                
                <div className="container-fluid">
                {errorMessage && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>{errorMessage?.status}</strong> {errorMessage?.message}
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                )}

                    <div className="alert alert-info" role="alert">
                        <i className="fas fa-info-circle me-2"></i>
                        You can now generate a <span className="fw-bold text-danger">Free License Key</span> for your EA, by selecting <span className="fw-bold text-danger">"Type" as "Subscription"</span> when generating the license key. Note that this license will require your clients to pay the subscription fee to use the Mobile app.
                    </div>

                    <div className="row">
                        <UserLicences licenseStats={licenseStats} isLoading={isLoading} />
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-xxl-4">
                            <div className="row">
                                <div className="col-xl-12 col-sm-6">
                                    <PurchaseKey />
                                </div>
                                <div className="col-xl-12 col-sm-6">
                                    <WelcomeJourneyCard />
                                </div>
                                <div className="col-xl-12 col-sm-6">
                                    <TopSellingEA userId={userId} />
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-8 col-xxl-8 col-lg-12 col-sm-12">
                            <SalesChart licenseStats={licenseStats} setIsLoading={setIsLoading} setLicenseStats={setLicenseStats} setErrorMessage={setErrorMessage} userId={userId} />
                        </div>
                    </div>
                    
                    

                </div>
            </div>
        </UserPageLayout>

    );
}
